import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase} from '@/components/a-interfaz/a-controlador';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Llamados PostVenta';
        this.Vista.Opciones.push(
            { Tipo: 'titulo', Titulo: 'Pedidos' },
            { Tipo: 'opcion', Icono: 'alpha-n-box', Modo: 'normal', Titulo: 'Normales' },
            { Tipo: 'opcion', Icono: 'alpha-m-box', Modo: 'mostrador', Titulo: 'Mostrador' },
            { Tipo: 'opcion', Icono: 'alpha-m-box', Modo: 'mercado-libre', Titulo: 'MercadoLibre' },
            { Tipo: 'opcion', Icono: 'alpha-i-box', Modo: 'tienda-intex', Titulo: 'Intex.com.ar' },
        )
    }

}

export const Controlador = new ControladorInterfaz();


